module.exports = __webpack_public_path__ + "img/countedServices.1da2b8a7.svg";